import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LoadingService } from 'src/app/services/loading.service';
import { MapService } from 'src/app/services/map.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
})
export class NotificationsModalComponent implements OnInit {
  @Output() showModal = new EventEmitter<boolean>();
  public alertTypes: any;
  ruta: string = '/map';
  notifications: any;
  selectedItem = 1;
  notificationsType: any[] = [];
  search: string = ''
  data: any;
  filters = {
    startDate: '',
    endDate: '',
    type: 0,
    state: '',
  };

  constructor(
    private notificationsService: NotificationsService,
    public _mapService: MapService,
    public loadingService: LoadingService,
  ) {}

  ngOnInit() {
    this.getAlertType();
  }

  setShowModal() {
    this.showModal.next(false);
  }

  getAlertType() {
    this.loadingService.show();
    this.notificationsService.getAlertTypes().subscribe((data) => {
      this.alertTypes = data;
      this.loadingService.hide();
    });
  }
  navigateRute(item) {
    this._mapService.setCenterMap(item.dmu.lat, item.dmu.lon,18, true);
  }

  getAlertFilter(selectedItem) {
    this.cleanAlerts()
    this.filters = { ...this.filters, type: selectedItem };
    this.loadingService.show();
    this.notificationsService.getAlerts(this.filters, true).subscribe((data) => {
      this.notificationsType = data.map((data) => {  return {...data, dmu_name: data.dmu.name}})
      this.loadingService.hide();
      if(this.notificationsType.length > 0 ){
        this.add(this.notificationsType)
      }
    });
  }
  
  add(alerts){
    alerts = alerts.map((alert) => {
      return {
        ...alert,
        lon: alert?.dmu?.lon, 
        lat:  alert?.dmu?.lat,
        model_setting_color: alert?.alert_type?.model_settings?.color,
        model_setting_z: alert?.alert_type?.model_settings?.z,
        name: alert?.name,
        dmu_name: alert.dmu_name,
        description: alert?.description,
        alert_type_name: alert.alert_type?.name
      }
    })
    this._mapService.addALert3d(alerts[0].alert_type?.model,'1', alerts, 
    {
      model_setting_color: alerts[0]?.alert_type?.model_settings?.color,
      model_setting_z: alerts[0]?.alert_type?.model_settings?.z,
      name: alerts[0]?.name,
      dmu_name: alerts[0]?.dmu_name,
      description: alerts[0]?.description
    })
  }

  cleanAlerts(){
    this.notificationsType  = [];
    if (this._mapService.map.getLayer('3d-alert')) {
      this._mapService.map.removeLayer('3d-alert');
    }
  }
}
